import "core-js/modules/es.array.concat";

var _Media, _Media2;

import React, { useRef, useCallback } from 'react'; // $FlowFixMe: untyped import

import Cropper from 'react-cropper';
import { useTranslation } from 'react-i18next';
import { Media } from "../../../../media";
import { ThemeProvider } from "../../../../theme";
import Button from '../../../Controls/Button';
import Grid from '../../../Layout/Grid';
import Modal from '../../../Utils/Modal';
import Icon from '../../Icon'; // $FlowFixMe: untyped import

import 'cropperjs/dist/cropper.css';
import styles from './CropperModal.scss';
var SAVE_IMAGE_PARAMS = ['image/jpeg', 0.95];

var CropperModal = function CropperModal(_ref) {
  var _ref$isOpened = _ref.isOpened,
      isOpened = _ref$isOpened === void 0 ? false : _ref$isOpened,
      _ref$aspectRatio = _ref.aspectRatio,
      aspectRatio = _ref$aspectRatio === void 0 ? 1 : _ref$aspectRatio,
      fileUrl = _ref.fileUrl,
      onSave = _ref.onSave,
      onCancel = _ref.onCancel;

  var _useTranslation = useTranslation(['photoUploader']),
      t = _useTranslation.t;

  var cropperRef = useRef(null);
  var cropImage = useCallback(function () {
    if (cropperRef.current) {
      var _cropperRef$current$g;

      (_cropperRef$current$g = cropperRef.current.getCroppedCanvas()).toBlob.apply(_cropperRef$current$g, [function (blob) {
        var _cropperRef$current$g2;

        onSave(blob, (_cropperRef$current$g2 = cropperRef.current.getCroppedCanvas()).toDataURL.apply(_cropperRef$current$g2, SAVE_IMAGE_PARAMS));
      }].concat(SAVE_IMAGE_PARAMS));
    }
  }, [cropperRef, onSave]);
  return /*#__PURE__*/React.createElement(Modal, {
    isOpened: isOpened,
    closeOnClickOutside: false,
    onClose: onCancel,
    className: styles.modalWrap,
    noContainer: true
  }, /*#__PURE__*/React.createElement(Grid.Container, {
    className: styles.cropperModal
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "close",
    size: "medium",
    color: "text",
    onClick: onCancel,
    className: styles.closeIcon
  })), /*#__PURE__*/React.createElement(Grid.Row, null, _Media || (_Media = /*#__PURE__*/React.createElement(Media, {
    greaterThanOrEqual: "lg"
  }, /*#__PURE__*/React.createElement(Grid.Item, {
    xl: 2,
    lg: 2
  }, "\xA0"))), /*#__PURE__*/React.createElement(Grid.Item, {
    xl: 4,
    lg: 4,
    sm: 4,
    xs: 4
  }, /*#__PURE__*/React.createElement(Cropper, {
    src: fileUrl,
    ref: cropperRef,
    className: styles.cropperWrap,
    aspectRatio: aspectRatio,
    autoCropArea: 1,
    viewMode: 1,
    wheelZoomRatio: 0.05,
    dragMode: "move",
    cropBoxMovable: false,
    cropBoxResizable: false,
    toggleDragModeOnDblclick: false,
    checkOrientation: false,
    background: false,
    rotatable: false,
    center: false,
    guides: false,
    minCropBoxWidth: 800,
    zoom: function zoom(e) {
      if (e.detail.ratio >= 1) {
        e.preventDefault();
      }
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.actions
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: "dark"
  }, /*#__PURE__*/React.createElement(Button, {
    styleType: "primary",
    size: "large",
    className: styles.button,
    onClick: cropImage,
    isFullWidth: true
  }, t('DONE'))), /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: "dark"
  }, /*#__PURE__*/React.createElement(Button, {
    size: "large",
    className: styles.button,
    onClick: onCancel,
    isFullWidth: true
  }, t('CANCEL'))))), _Media2 || (_Media2 = /*#__PURE__*/React.createElement(Media, {
    greaterThanOrEqual: "lg"
  }, /*#__PURE__*/React.createElement(Grid.Item, {
    xl: 4,
    lg: 2
  }, "\xA0"))))));
};

export default CropperModal;